<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <Activity :type="type" pageType="add"></Activity>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import Activity from "@/components/activity";
export default {
  data() {
    return {
      navBlock: "活動  /  活動列表",
      navtitle: "新增活動",
      type: "add",
    };
  },
  components: {
    NavBar,
    Activity,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/activity/addActivity.vue